import LegalLayout from "@/components/legal/LegalLayout";
import Seo from "@/components/Seo";
import { TRADING_NAME } from "@/constants/company";
import { Button } from "@/components/ui/button";
import { openCookiePreferences } from "@/lib/consent";

export default function Cookies() {
  return (
    <>
      <Seo
        title="Cookie Policy"
        description={`How ${TRADING_NAME} uses cookies and how you can manage your preferences.`}
        path="/cookies"
      />
      <LegalLayout title="Cookie Policy" subtitle="Last updated: January 2025">
      <section className="space-y-8 not-prose">
        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">1. What Are Cookies?</h2>
          <p className="text-base leading-relaxed text-[#2A2A33]">
            Cookies are small text files stored on your device when you visit our website. They help us
            provide essential functionality, understand how you use our site, and (with your consent)
            deliver relevant marketing.
          </p>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">2. Types of Cookies We Use</h2>
          <ul className="list-disc space-y-2 pl-6 text-base leading-relaxed text-[#2A2A33]">
            <li>
              <strong className="font-semibold text-ink">Essential cookies</strong> — Required for site functionality.
              These cannot be disabled.
            </li>
            <li>
              <strong className="font-semibold text-ink">Analytics cookies</strong> — Help us understand user behaviour
              (e.g. Google Analytics). Only loaded with your consent.
            </li>
            <li>
              <strong className="font-semibold text-ink">Marketing cookies</strong> — Used for targeted advertising
              and session recording (e.g. Hotjar). Only loaded with your consent.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">3. Managing Your Preferences</h2>
          <p className="mb-4 text-base leading-relaxed text-[#2A2A33]">
            You can change your cookie preferences at any time using the button below or through your
            browser settings.
          </p>
          <Button
            onClick={openCookiePreferences}
            className="h-12 rounded-2xl bg-lime px-6 font-display text-base font-bold tracking-tight text-ink hover:bg-lime"
          >
            Change cookie preferences
          </Button>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">4. Third-Party Cookies</h2>
          <p className="text-base leading-relaxed text-[#2A2A33]">
            With your consent, we may use third-party services including Google Analytics and Hotjar.
            These providers have their own privacy policies governing how they use data.
          </p>
        </div>

        <div>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-ink">5. Contact</h2>
          <p className="text-base leading-relaxed text-[#2A2A33]">
            Questions about cookies:{" "}
            <a href="mailto:privacy@powlo.co" className="font-semibold text-indigo hover:underline">privacy@powlo.co</a>
          </p>
        </div>
      </section>
    </LegalLayout>
    </>
  );
}
